var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit",style:({top: _vm.top ? _vm.top + 'px' : '300px'})},[_c('img',{attrs:{"src":require("@/assets/img/WechatIMG1225.png"),"alt":""}}),_c('span',{staticClass:"desc"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }